<!-- 
An item in the connectivity panel.
-->
<template>
  <div :class="padding" class="text-xs-left">
    <v-avatar :color="color" :size="size">
      <v-icon :small="small" color="white">{{ icon }}</v-icon>
    </v-avatar>
    <span :class="titlePadding" class="subheading" style="position:relative;top:2px;">
      {{ title }}
      <span class="caption pl-1">{{ subtitle }}</span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    connected: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    small: {
      type: Boolean,
      default: false
    },
    notApplicable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    size() {
      return this.small ? 20 : 32;
    },
    titlePadding() {
      return this.small ? "pl-1" : "pl-3";
    },
    padding() {
      return this.small ? "pl-1 pb-3" : "pl-5 pb-3";
    },
    color() {
      if (this.notApplicable) {
        return "orange";
      }
      return this.connected ? "success" : "error";
    },
    icon() {
      if (this.notApplicable) return "power_off";
      if (this.connected) return "done";
      return "close";
    }
  }
};
</script>
